module.exports = __webpack_public_path__ + "img/bratthet.f2c46589.jpg";